<div class="section">
  <h2>Impersonate a User</h2>

  <div>
    <input
      [(ngModel)]="formImpersonateUser"
      (ngModelChange)="impersonateError = null"
      [ngClass]="{'error': impersonateError}"
      placeholder="Enter username"
    >
    <div class="label">
      Username
    </div>
  </div>

  <button
    (click)="submitImpersonateUser()"
    [ngClass]="{'loading': isLoadingImpersonate}"
  >
    <span>Start Impersonation</span>
    <motn-spinner></motn-spinner>
  </button>

  @if (impersonateError) {
    <div class="error-message">
      <strong>Error:</strong>
      <pre>{{ impersonateError | json }}</pre>
    </div>
  }
</div>

<div class="section">
  <h2>Change Owner</h2>

  <div>
    <select
      [(ngModel)]="formChangeOwnerObjectType"
    >
      <option value="hub">Hub</option>
<!--      <option value="device">Device</option>-->
<!--      <option value="tile">Tile</option>-->
<!--      <option value="app">App</option>-->
    </select>
    <div class="label">
      Object Type
    </div>
  </div>

  <div>
    <input
      [(ngModel)]="formChangeOwnerObjectId"
      placeholder="e.g., 12345"
    >
    <div class="label">
      Object ID
    </div>
  </div>

  <div>
    <input
      [(ngModel)]="formChangeOwnerOldId"
      placeholder="e.g., 6237323004"
    >
    <div class="label">
      Current Owner ID
    </div>
  </div>

  <div>
    <input
      [(ngModel)]="formChangeOwnerNewId"
      placeholder="e.g., 6237323004"
    >
    <div class="label">
      New Owner ID
    </div>
  </div>

  <button
    (click)="submitChangeOwner()"
    [ngClass]="{'loading': isLoadingChangeOwner}"
  >
    <span>Change Owner</span>
    <motn-spinner></motn-spinner>
  </button>

  @if (changeOwnerSuccess) {
    <div class="success-message">
      Owner changed successfully!
    </div>
  }

  @if (changeOwnerError) {
    <div class="error-message">
      <strong>Error:</strong>
      <pre>{{ changeOwnerError | json }}</pre>
    </div>
  }
</div>

<div class="section">
  <h2>User Lookup</h2>

  <div>
    <input
      [(ngModel)]="formUserLookupUsername"
      placeholder="Enter username"
      (keydown.enter)="submitUserLookup()"
    >
    <div class="label">
      Username
    </div>
  </div>

  <button
    (click)="submitUserLookup()"
    [ngClass]="{'loading': isLoadingUserLookup}"
  >
    <span>Lookup User</span>
    <motn-spinner></motn-spinner>
  </button>

  @if (userLookupResult) {
    <div class="result-box">
      <pre>{{ userLookupResult | json }}</pre>
    </div>
  }
</div>
